import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-modal__content" }
const _hoisted_2 = { class: "confirm-modal__message-section" }
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  width: "32",
  height: "32"
}
const _hoisted_4 = {
  key: 0,
  fill: "currentColor",
  d: "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"
}
const _hoisted_5 = {
  key: 1,
  fill: "currentColor",
  d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
}
const _hoisted_6 = {
  key: 2,
  fill: "currentColor",
  d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
}
const _hoisted_7 = {
  key: 3,
  fill: "currentColor",
  d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
}
const _hoisted_8 = { class: "confirm-modal__text" }
const _hoisted_9 = { class: "confirm-modal__message" }
const _hoisted_10 = { class: "confirm-modal__details-text" }
const _hoisted_11 = { class: "confirm-modal__actions" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import AppModal from '../base/Modal.vue'
import AppButton from '../base/AppButton.vue'

// Define props interface
interface Props {
  isVisible?: boolean
  title?: string
  message: string
  details?: string
  confirmText?: string
  cancelText?: string
  type?: 'warning' | 'danger' | 'info' | 'success'
  loading?: boolean
  closeOnOverlayClick?: boolean
}

interface Emits {
  confirm: []
  cancel: []
  close: []
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    isVisible: { type: Boolean, default: false },
    title: { default: '' },
    message: {},
    details: { default: '' },
    confirmText: { default: '' },
    cancelText: { default: '' },
    type: { default: 'warning' },
    loading: { type: Boolean, default: false },
    closeOnOverlayClick: { type: Boolean, default: true }
  },
  emits: ["confirm", "cancel", "close"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props

// Define emits interface
const emit = __emit

// i18n
const { t } = useI18n()

// Computed properties
const confirmButtonVariant = computed((): string => {
  const variants = {
    warning: 'warning',
    danger: 'danger',
    info: 'primary',
    success: 'success'
  }
  return variants[props.type as keyof typeof variants] || variants.warning
})

const defaultTitle = computed((): string => {
  if (props.title) return props.title
  const titles = {
    warning: t('common.confirm'),
    danger: t('common.delete'),
    info: t('common.info'),
    success: t('common.success')
  }
  return titles[props.type as keyof typeof titles] || titles.warning
})

const defaultConfirmText = computed((): string => {
  if (props.confirmText) return props.confirmText
  const texts = {
    warning: t('common.confirm'),
    danger: t('common.delete'),
    info: t('common.ok'),
    success: t('common.ok')
  }
  return texts[props.type as keyof typeof texts] || texts.warning
})

const defaultCancelText = computed((): string => {
  return props.cancelText || t('common.cancel')
})

// Methods
const handleConfirm = (): void => {
  emit('confirm')
}

const handleCancel = (): void => {
  emit('cancel')
  emit('close')
}

const handleOverlayClick = (): void => {
  if (props.closeOnOverlayClick && !props.loading) {
    handleCancel()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    show: _ctx.isVisible,
    title: defaultTitle.value,
    size: 'medium',
    gradientHeader: false,
    loading: _ctx.loading,
    closeOnBackdropClick: _ctx.closeOnOverlayClick,
    onClose: handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(AppButton, {
          type: "button",
          variant: "outline",
          onClick: handleCancel,
          disabled: _ctx.loading,
          class: "confirm-modal__btn confirm-modal__btn--cancel"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(defaultCancelText.value), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(AppButton, {
          type: "button",
          variant: confirmButtonVariant.value,
          onClick: handleConfirm,
          disabled: _ctx.loading,
          loading: _ctx.loading,
          class: "confirm-modal__btn confirm-modal__btn--confirm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(defaultConfirmText.value), 1)
          ]),
          _: 1
        }, 8, ["variant", "disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["confirm-modal__icon", `confirm-modal__icon--${_ctx.type}`])
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              (_ctx.type === 'warning')
                ? (_openBlock(), _createElementBlock("path", _hoisted_4))
                : (_ctx.type === 'danger')
                  ? (_openBlock(), _createElementBlock("path", _hoisted_5))
                  : (_ctx.type === 'success')
                    ? (_openBlock(), _createElementBlock("path", _hoisted_6))
                    : (_openBlock(), _createElementBlock("path", _hoisted_7))
            ]))
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.message), 1)
          ])
        ]),
        (_ctx.details)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["confirm-modal__details", `confirm-modal__details--${_ctx.type}`])
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                width: "20",
                height: "20"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.details), 1)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show", "title", "loading", "closeOnBackdropClick"]))
}
}

})